import React from 'react';
import { MortgageDashboard } from './components/MortgageDashboard';
export function App() {
  return <MortgageDashboard data-id="element-0" />;
}